import { render, staticRenderFns } from "./safetyValveRuptureDiskDetail.vue?vue&type=template&id=4cc59a7a"
import script from "./safetyValveRuptureDiskDetail.vue?vue&type=script&lang=js"
export * from "./safetyValveRuptureDiskDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4cc59a7a')) {
      api.createRecord('4cc59a7a', component.options)
    } else {
      api.reload('4cc59a7a', component.options)
    }
    module.hot.accept("./safetyValveRuptureDiskDetail.vue?vue&type=template&id=4cc59a7a", function () {
      api.rerender('4cc59a7a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/psi/pfi/safetyValveRuptureDiskDetail.vue"
export default component.exports